import { ResolveFn } from '@angular/router';

/**
 * This is a funny thing.
 * 
 * This is used to make sure there is at least X amount of milliseconds
 * between route resolutions. This helps the "ripple" animation not appear
 * too laggy between view transitions.
 */
export const minDelayResolver: ResolveFn<boolean> = async () => {
  return await new Promise<boolean>(resolve => {
    setTimeout(() => {
      resolve(true);
    }, 100);
  });
};
